export default __webpack_public_path__ + "static/media/work.379e5824.svg";